module.exports = __webpack_public_path__ + "static/media/review-quote_16.bd20ba1e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/review-quote_16.svg
// module id = 902
// module chunks = 0